/**
 * Fiskehandleren Delivery V2 — Cart sidebar redesign
 * En samlet widget: pris/frakt/total + postnr + dato/tid + checkout
 */
(function () {
  'use strict';

  var API_BASE = window.__FH_DELIVERY_API || '';
  var STORAGE_KEY = 'fh_delivery_v2';
  var CART_UPDATE_URL = '/cart/update.js';
  var _selfFetch = false;
  var _updateTimer = null;
  var DAY_NAMES = ['sondag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lordag'];
  var DAY_NAMES_CAP = ['Søndag', 'Mandag', 'Tirsdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lørdag'];
  var MONTH_NAMES = ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember'];

  var state = loadState();

  function loadState() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (raw) return JSON.parse(raw);
    } catch (e) { /* ignore */ }
    return { postnr: null, zone: null, nextDates: [], selectedDate: null, selectedSlot: null, slots: [], deliveryNote: '', notHome: false };
  }

  function saveState() {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) { /* ignore */ }
  }

  function clearState() {
    state = { postnr: null, zone: null, nextDates: [], selectedDate: null, selectedSlot: null, slots: [], deliveryNote: '', notHome: false };
    saveState();
  }

  // ── API ────────────────────────────────────────────────────────────────────

  var _slotsReqId = 0;
  var _priceReqId = 0;

  function esc(str) {
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  function safeFetch(url, opts, retries) {
    if (retries === undefined) retries = 2;
    return fetch(url, opts).then(function (r) {
      if (!r.ok) {
        if (r.status >= 500 && retries > 0) {
          return new Promise(function (resolve) { setTimeout(resolve, 1000); })
            .then(function () { return safeFetch(url, opts, retries - 1); });
        }
        throw new Error('API-feil: ' + r.status);
      }
      return r.json();
    }).catch(function (err) {
      if (err.message && err.message.indexOf('API-feil') === 0) throw err;
      if (retries > 0) {
        return new Promise(function (resolve) { setTimeout(resolve, 1000); })
          .then(function () { return safeFetch(url, opts, retries - 1); });
      }
      throw new Error('Nettverksfeil — prøv igjen');
    });
  }

  function apiCall(action, params) {
    var qs = Object.keys(params || {}).map(function (k) {
      return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
    }).join('&');
    var url = API_BASE + '/api/delivery/public?action=' + action + (qs ? '&' + qs : '');
    return safeFetch(url);
  }

  function apiPostAction(action, body) {
    return safeFetch(API_BASE + '/api/delivery/public?action=' + action, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
  }

  function checkPostnr(postnr) { return apiPostAction('check', { postnr: postnr }); }

  function getSlots(zoneId, date) {
    var myId = ++_slotsReqId;
    var params = { zone_id: zoneId, date: date };
    if (state.postnr) params.postnr = state.postnr;
    return apiCall('slots', params).then(function (data) {
      if (myId !== _slotsReqId) return Promise.reject('stale');
      return data;
    });
  }

  function getPrice(orderValue, slotId) {
    var myId = ++_priceReqId;
    return apiCall('price', { order_value: orderValue, slot_id: slotId }).then(function (data) {
      if (myId !== _priceReqId) return Promise.reject('stale');
      return data;
    });
  }

  // ── Date helpers ────────────────��──��───────────────────────────────────────

  function parseDate(str) {
    var parts = str.split('-');
    return new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
  }

  function formatDateShort(str) {
    var d = parseDate(str);
    return DAY_NAMES_CAP[d.getDay()] + ' ' + d.getDate() + '. ' + MONTH_NAMES[d.getMonth()];
  }

  function dayNameCap(str) { return DAY_NAMES_CAP[parseDate(str).getDay()]; }
  function dayNum(str) { return parseDate(str).getDate(); }
  function monthName(str) { return MONTH_NAMES[parseDate(str).getMonth()]; }

  function formatTime(timeStr) {
    if (!timeStr) return '';
    return timeStr.substring(0, 5);
  }

  // ── Cart attributes ────────────────────────────────────────────────────────

  function updateCartAttributes(attrs) {
    _selfFetch = true;
    return fetch(CART_UPDATE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
    }).then(function (r) { setTimeout(function () { _selfFetch = false; }, 1000); return r.json(); })
      .catch(function (e) { setTimeout(function () { _selfFetch = false; }, 1000); throw e; });
  }

  function syncCartAttributes() {
    if (!state.postnr || !state.selectedDate || !state.selectedSlot) return Promise.resolve();
    var slot = state.slots.find(function (s) { return s.slot_id === state.selectedSlot; });
    var slotLabel = slot ? (slot.start + ' – ' + slot.end) : '';
    var attrs = {
      'Delivery-Date': state.selectedDate,
      'Delivery-Day': state.selectedDate ? DAY_NAMES[parseDate(state.selectedDate).getDay()] : '',
      'Delivery-Time': slotLabel,
      'Delivery-Zone': state.zone ? state.zone.name : '',
      'Delivery-Postnr': state.postnr,
      'Checkout-Method': 'delivery',
    };
    if (state.deliveryNote) {
      attrs['Delivery-Note'] = state.deliveryNote;
    } else if (state.notHome) {
      attrs['Delivery-Note'] = 'Ikke hjemme — legg ved doeren';
    }
    return updateCartAttributes(attrs);
  }

  // ── Product page ──────────────────────────────────────────────────────────

  function initProductDelivery() {
    var els = document.querySelectorAll('.fh-dprod');
    if (!els.length) return;

    if (state.nextDates && state.nextDates.length > 0) {
      var _now = new Date();
      var _oslo = new Date(_now.toLocaleString('en-US', {timeZone: 'Europe/Oslo'}));
      var _todayStr = _oslo.getFullYear() + '-' +
        String(_oslo.getMonth()+1).padStart(2,'0') + '-' +
        String(_oslo.getDate()).padStart(2,'0');
      state.nextDates = state.nextDates.filter(function(d) { return d > _todayStr; });
      if (state.selectedDate && state.selectedDate <= _todayStr) {
        state.selectedDate = state.nextDates[0] || null;
        state.selectedSlot = null;
      }
      saveState();
    }

    els.forEach(function (el) {
      if (state.postnr && state.zone && state.nextDates.length > 0) { renderProductConfirmed(el); }
      else { renderProductPrompt(el); }
    });
  }

  function renderProductPrompt(el) {
    el.innerHTML = '';
    el.style.display = 'none';
  }

  function renderProductConfirmed(el) {
    var date = state.nextDates[0] || '';
    var cutoffDate = '';
    if (date) {
      var d = parseDate(date); d.setDate(d.getDate() - 1);
      cutoffDate = DAY_NAMES_CAP[d.getDay()] + ' kl 23:59';
    }
    el.innerHTML =
      '<div class="fh-dprod-box">' +
        '<svg width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="1" y="3" width="15" height="13" rx="2"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>' +
        '<div class="fh-dprod-text">' +
          '<p>Leveres ' + formatDateShort(date) + ' til ' + esc(state.postnr) + '</p>' +
          (cutoffDate ? '<span class="fh-dprod-sub">Bestill innen ' + cutoffDate + '</span>' : '') +
        '</div>' +
        '<a class="fh-dprod-change" href="#">Endre</a>' +
      '</div>';
    el.querySelector('.fh-dprod-change').addEventListener('click', function (e) {
      e.preventDefault(); clearState(); renderProductPrompt(el);
    });
  }

  // ── Cart widget — Main ────────────────────────────────────────────────────

  var dateOffset = 0;
  var DATES_PER_PAGE = 3;

  function initCartWidget() {
    var widgets = document.querySelectorAll('.fh-dcart');
    if (!widgets.length) return;
    widgets.forEach(function (w) { renderCartWidget(w); });
  }

  function widgetHeader() {
    return '<div class="fh-dcart-header">' +
      '<svg width="22" height="22" fill="none" stroke="white" stroke-width="2" viewBox="0 0 24 24"><rect x="1" y="3" width="15" height="13" rx="2"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>' +
      '<div><h3>Bestilling og levering</h3><p>Levert til døren mellom 14:00 og 22:00</p></div>' +
    '</div>';
  }

  function checkoutBtnHtml(mode) {
    if (mode === 'saving') {
      return '<div class="fh-dcart-action">' +
        '<button type="button" class="fh-dcart-checkout-btn fh-dcart-checkout-btn--saving" disabled>Til kassen</button>' +
      '</div>';
    }
    if (mode === 'ready') {
      return '<div class="fh-dcart-action">' +
        '<button type="button" class="fh-dcart-checkout-btn" data-fh-checkout>Til kassen</button>' +
      '</div>';
    }
    return '<div class="fh-dcart-action">' +
      '<button type="button" class="fh-dcart-checkout-btn fh-dcart-checkout-btn--disabled" disabled>Velg levering før du bestiller</button>' +
    '</div>';
  }

  // ── Cart: Postnr not yet entered ──────────────────────────────────────────

  function renderCartPostnrPrompt(w) {
    w.innerHTML =
      '<div class="fh-dcart-widget">' +
        widgetHeader() +
        '<div class="fh-dcart-body">' +
          '<div class="fh-dcart-price-top" id="fh-dcart-price-top"></div>' +
          '<div class="fh-dcart-section-divider"></div>' +
          '<p class="fh-dcart-label">Hvor skal vi levere?</p>' +
          '<div class="fh-dcart-postnr-form">' +
            '<input type="text" class="fh-dcart-postnr-input" placeholder="Skriv postnummer" maxlength="4" inputmode="numeric" pattern="[0-9]*">' +
            '<button type="button" class="fh-dcart-postnr-btn">' +
              '<svg class="fh-dcart-postnr-icon" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>' +
              '<span class="fh-dcart-spinner" style="display:none"></span>' +
            '</button>' +
          '</div>' +
          '<p class="fh-dcart-postnr-msg"></p>' +
          checkoutBtnHtml(false) +
        '</div>' +
      '</div>';

    updateTopPricing(w);

    var input = w.querySelector('.fh-dcart-postnr-input');
    var btn = w.querySelector('.fh-dcart-postnr-btn');
    var msg = w.querySelector('.fh-dcart-postnr-msg');
    btn.addEventListener('click', function () { doCartCheck(input, msg, w); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') doCartCheck(input, msg, w); });
  }

  function setPostnrLoading(w, loading) {
    var input = w.querySelector('.fh-dcart-postnr-input');
    var btn = w.querySelector('.fh-dcart-postnr-btn');
    var icon = w.querySelector('.fh-dcart-postnr-icon');
    var spinner = w.querySelector('.fh-dcart-spinner');
    if (input) { input.disabled = loading; input.classList.toggle('fh-dcart-postnr-input--loading', loading); }
    if (btn) btn.disabled = loading;
    if (icon) icon.style.display = loading ? 'none' : '';
    if (spinner) spinner.style.display = loading ? '' : 'none';
  }

  function doCartCheck(input, msg, w) {
    var val = (input.value || '').trim().replace(/\s/g, '').padStart(4, '0');
    if (val.length < 4 || !/^\d{4}$/.test(val)) {
      msg.textContent = 'Skriv inn et gyldig postnummer';
      msg.className = 'fh-dcart-postnr-msg fh-dcart-postnr-msg--err';
      return;
    }

    msg.innerHTML = '<span class="fh-dcart-spinner fh-dcart-spinner--sm"></span> Sjekker postnummer...';
    msg.className = 'fh-dcart-postnr-msg fh-dcart-postnr-msg--loading';
    setPostnrLoading(w, true);

    checkPostnr(val).then(function (data) {
      if (data.available) {
        state.postnr = val; state.zone = data.zone; state.nextDates = data.next_dates || [];
        state.selectedDate = state.nextDates[0] || null; state.selectedSlot = null; state.slots = [];
        saveState();
        var body = w.querySelector('.fh-dcart-body');
        if (body) {
          body.style.transition = 'opacity 0.2s ease';
          body.style.opacity = '0';
          setTimeout(function () {
            renderCartWidget(w);
            var nb = w.querySelector('.fh-dcart-body');
            if (nb) { nb.style.opacity = '0'; nb.style.transition = 'opacity 0.35s ease'; requestAnimationFrame(function () { nb.style.opacity = '1'; }); }
            initProductDelivery();
          }, 200);
        } else {
          renderCartWidget(w); initProductDelivery();
        }
      } else {
        msg.textContent = 'Vi leverer dessverre ikke til ' + val + ' ennå';
        msg.className = 'fh-dcart-postnr-msg fh-dcart-postnr-msg--err';
        setPostnrLoading(w, false);
      }
    }).catch(function () {
      msg.textContent = 'Noe gikk galt. Prøv igjen.';
      msg.className = 'fh-dcart-postnr-msg fh-dcart-postnr-msg--err';
      setPostnrLoading(w, false);
    });
  }

  // ── Cart: Full widget (postnr confirmed) ──────────────────────────────────

  var DATE_GAP = 6;

  function buildAllDateCards(dates, selected) {
    var html = '';
    for (var i = 0; i < dates.length; i++) {
      var dateStr = dates[i];
      var sel = (selected === dateStr) ? ' fh-dcart-date--sel' : '';
      var badge = (i === 0) ? '<span class="fh-dcart-badge">Neste</span>' : '';
      html += '<button type="button" class="fh-dcart-date' + sel + '" data-date="' + dateStr + '">' +
        badge +
        '<span class="fh-dcart-date-day">' + dayNameCap(dateStr) + '</span>' +
        '<span class="fh-dcart-date-num">' + dayNum(dateStr) + '</span>' +
        '<span class="fh-dcart-date-month">' + monthName(dateStr) + '</span>' +
      '</button>';
    }
    return html;
  }

  var _sliderCardWidth = 0;

  function calcCardWidth(viewport) {
    var vpWidth = viewport.offsetWidth;
    if (vpWidth <= 0) return 90;
    return Math.floor((vpWidth - (DATES_PER_PAGE - 1) * DATE_GAP) / DATES_PER_PAGE);
  }

  function applyCardWidths(w) {
    var viewport = w.querySelector('.fh-dcart-dates-viewport');
    if (!viewport) return;
    _sliderCardWidth = calcCardWidth(viewport);
    var cards = w.querySelectorAll('.fh-dcart-date');
    cards.forEach(function (c) { c.style.width = _sliderCardWidth + 'px'; c.style.minWidth = _sliderCardWidth + 'px'; });
    slideDates(w, _sliderCardWidth);
  }

  function initDateSlider(w) {
    var viewport = w.querySelector('.fh-dcart-dates-viewport');
    if (!viewport) return;

    applyCardWidths(w);
    updateArrowVisibility(w);

    w.querySelector('#fh-date-left').addEventListener('click', function () {
      dateOffset = Math.max(0, dateOffset - 1);
      slideDates(w, _sliderCardWidth);
      updateArrowVisibility(w);
    });
    w.querySelector('#fh-date-right').addEventListener('click', function () {
      dateOffset = Math.min(state.nextDates.length - DATES_PER_PAGE, dateOffset + 1);
      slideDates(w, _sliderCardWidth);
      updateArrowVisibility(w);
    });

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { applyCardWidths(w); updateArrowVisibility(w); }, 150);
    });
  }

  function slideDates(w, cardWidth) {
    var track = w.querySelector('.fh-dcart-dates-track');
    if (!track) return;
    var tx = -(dateOffset * (cardWidth + DATE_GAP));
    track.style.transform = 'translateX(' + tx + 'px)';
  }

  function updateArrowVisibility(w) {
    var l = w.querySelector('#fh-date-left');
    var r = w.querySelector('#fh-date-right');
    if (l) { l.style.visibility = dateOffset > 0 ? 'visible' : 'hidden'; }
    if (r) { r.style.visibility = dateOffset + DATES_PER_PAGE < state.nextDates.length ? 'visible' : 'hidden'; }
  }

  function renderCartWidget(w) {
    // Background refresh zone name (fixes stale cached names)
    if (state.postnr && state.zone) {
      checkPostnr(state.postnr).then(function(data) {
        if (data.available && data.zone && data.zone.name !== state.zone.name) {
          state.zone = data.zone;
          saveState();
          var confirm = w.querySelector('.fh-dcart-confirm p');
          if (confirm) confirm.innerHTML = 'Leverer til <strong>' + esc(state.postnr) + ' ' + esc(state.zone.name) + '</strong>';
        }
      }).catch(function() {});
    }
    // Validate cached dates are not stale
    if (state.nextDates && state.nextDates.length > 0 && state.postnr) {
      var _now = new Date();
      var _oslo = new Date(_now.toLocaleString('en-US', {timeZone: 'Europe/Oslo'}));
      var _todayStr = _oslo.getFullYear() + '-' +
        String(_oslo.getMonth()+1).padStart(2,'0') + '-' +
        String(_oslo.getDate()).padStart(2,'0');
      var freshDates = state.nextDates.filter(function(d) { return d > _todayStr; });
      if (freshDates.length < state.nextDates.length ||
          (state.selectedDate && state.selectedDate <= _todayStr)) {
        state.nextDates = freshDates;
        if (state.selectedDate && state.selectedDate <= _todayStr) {
          state.selectedDate = freshDates[0] || null;
          state.selectedSlot = null;
          state.slots = [];
        }
        saveState();
        if (freshDates.length === 0 && state.postnr) {
          checkPostnr(state.postnr).then(function(data) {
            if (data.available) {
              state.zone = data.zone;
              state.nextDates = data.next_dates || [];
              state.selectedDate = state.nextDates[0] || null;
              state.selectedSlot = null;
              state.slots = [];
              saveState();
              renderCartWidget(w);
            }
          });
          renderCartPostnrPrompt(w);
          return;
        }
      }
    }

    if (!state.postnr || !state.zone || !state.nextDates.length) {
      renderCartPostnrPrompt(w);
      return;
    }

    var allDatesHtml = buildAllDateCards(state.nextDates, state.selectedDate);
    var hasFullSelection = state.postnr && state.selectedDate && state.selectedSlot;

    w.innerHTML =
      '<div class="fh-dcart-widget">' +
        widgetHeader() +
        '<div class="fh-dcart-body">' +

          '<div class="fh-dcart-price-top" id="fh-dcart-price-top"></div>' +

          '<div class="fh-dcart-section-divider"></div>' +

          '<div class="fh-dcart-confirm">' +
            '<div class="fh-dcart-check"><svg fill="none" stroke="white" stroke-width="2.5" viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg></div>' +
            '<p>Leverer til <strong>' + esc(state.postnr) + ' ' + esc(state.zone.name) + '</strong></p>' +
            '<a class="fh-dcart-change" href="#">Endre</a>' +
          '</div>' +

          '<div class="fh-dcart-date-header">' +
            '<p class="fh-dcart-label">Velg leveringsdag</p>' +
            '<button type="button" class="fh-dcart-cal-btn" id="fh-dcart-cal-btn">' +
              '<svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>' +
              ' Kalender' +
            '</button>' +
          '</div>' +
          '<div class="fh-dcart-date-row">' +
            '<button type="button" class="fh-dcart-arrow fh-dcart-arrow--left" id="fh-date-left"><svg width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg></button>' +
            '<div class="fh-dcart-dates-viewport"><div class="fh-dcart-dates-track">' + allDatesHtml + '</div></div>' +
            '<button type="button" class="fh-dcart-arrow fh-dcart-arrow--right" id="fh-date-right"><svg width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M9 18l6-6-6-6"/></svg></button>' +
          '</div>' +

          '<p class="fh-dcart-label">Velg tidsvindu</p>' +
          '<div class="fh-dcart-slots" id="fh-dcart-slots"></div>' +

          '<div class="fh-dcart-cutoff" id="fh-dcart-cutoff"></div>' +

          '<div class="fh-dcart-note-section">' +
            '<textarea class="fh-dcart-note-input" id="fh-dcart-note" placeholder="Leveringsnotat (f.eks. ringeklokke, etasje, portkode...)" rows="2" maxlength="200"></textarea>' +
          '</div>' +

          '<div class="fh-dcart-nothome" id="fh-dcart-nothome">' +
            '<label class="fh-dcart-nothome-toggle">' +
              '<input type="checkbox" id="fh-dcart-nothome-check">' +
              '<span class="fh-dcart-nothome-label">Jeg er ikke hjemme — legg ved døren</span>' +
            '</label>' +
            '<div class="fh-dcart-nothome-panel" id="fh-dcart-nothome-panel" style="display:none">' +
              '<div class="fh-dcart-nothome-warning">' +
                '<svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>' +
                '<span>Frossen vare — må i fryseren innen 2 timer. Etter levering er ansvaret ditt.</span>' +
              '</div>' +
            '</div>' +
          '</div>' +

          '<div class="fh-dcart-trust">' +
            '<div class="fh-dcart-trust-item">' +
              '<svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.362 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>' +
              '<span>Du får SMS med oppdateringer på leveringsdagen</span>' +
            '</div>' +
          '</div>' +

          checkoutBtnHtml(hasFullSelection ? 'ready' : false) +

        '</div>' +
      '</div>';

    // ── Bindings ──

    updateTopPricing(w);

    w.querySelectorAll('.fh-dcart-date').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.selectedDate = btn.dataset.date;
        state.selectedSlot = null;
        saveState();
        w.querySelectorAll('.fh-dcart-date').forEach(function (b) { b.classList.remove('fh-dcart-date--sel'); });
        btn.classList.add('fh-dcart-date--sel');
        loadSlots(w);
      });
    });

    initDateSlider(w);

    w.querySelector('.fh-dcart-change').addEventListener('click', function (e) {
      e.preventDefault(); clearState(); renderCartWidget(w);
    });

    if (!window.__fhCalDelegated) {
      window.__fhCalDelegated = true;
      document.addEventListener('click', function (ev) {
        var calTarget = ev.target.closest('#fh-dcart-cal-btn');
        if (!calTarget) return;
        ev.stopPropagation();
        var existing = document.getElementById('fh-cal-popup');
        var ww = calTarget.closest('.fh-dcart');
        if (existing) { closeCalendar(); } else if (ww) { openCalendar(ww); }
      });
    }

    var noteInput = w.querySelector('#fh-dcart-note');
    if (noteInput) {
      noteInput.value = state.deliveryNote || '';
      var noteTimer = null;
      noteInput.addEventListener('input', function () {
        state.deliveryNote = noteInput.value; saveState();
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function () { syncCartAttributes(); }, 500);
      });
    }

    var nothomeCheck = w.querySelector('#fh-dcart-nothome-check');
    var nothomePanel = w.querySelector('#fh-dcart-nothome-panel');
    if (nothomeCheck && nothomePanel) {
      nothomeCheck.checked = state.notHome || false;
      nothomePanel.style.display = state.notHome ? 'block' : 'none';
      nothomeCheck.addEventListener('change', function () {
        state.notHome = nothomeCheck.checked;
        nothomePanel.style.display = state.notHome ? 'block' : 'none';
        saveState(); syncCartAttributes();
      });
    }

    if (state.selectedDate) loadSlots(w);
  }

  // ── Calendar popup ─────────────���────────���────────────��────────────────

  var calViewMonth = null;
  var calViewYear = null;

  function openCalendar(w) {
    closeCalendar();
    var btn = w.querySelector('#fh-dcart-cal-btn');
    if (!btn) return;

    var now = new Date();
    if (state.selectedDate) {
      var sel = parseDate(state.selectedDate);
      calViewMonth = sel.getMonth();
      calViewYear = sel.getFullYear();
    } else {
      calViewMonth = now.getMonth();
      calViewYear = now.getFullYear();
    }

    var popup = document.createElement('div');
    popup.className = 'fh-cal-popup';
    popup.id = 'fh-cal-popup';
    renderCalendarMonth(popup, w);

    var header = w.querySelector('.fh-dcart-date-header');
    if (header) {
      header.style.position = 'relative';
      header.appendChild(popup);
    }

    requestAnimationFrame(function () { popup.classList.add('fh-cal-popup--open'); });

    setTimeout(function () {
      document.addEventListener('click', calOutsideClick);
      document.addEventListener('keydown', calEscPress);
    }, 0);
  }

  function closeCalendar() {
    var popup = document.getElementById('fh-cal-popup');
    if (popup) {
      popup.classList.remove('fh-cal-popup--open');
      setTimeout(function () { if (popup.parentNode) popup.parentNode.removeChild(popup); }, 150);
    }
    document.removeEventListener('click', calOutsideClick);
    document.removeEventListener('keydown', calEscPress);
  }

  function calOutsideClick(e) {
    var popup = document.getElementById('fh-cal-popup');
    var btn = document.getElementById('fh-dcart-cal-btn');
    if (popup && !popup.contains(e.target) && (!btn || !btn.contains(e.target))) closeCalendar();
  }

  function calEscPress(e) { if (e.key === 'Escape') closeCalendar(); }

  function renderCalendarMonth(popup, w) {
    var availSet = {};
    (state.nextDates || []).forEach(function (d) { availSet[d] = true; });

    var first = new Date(calViewYear, calViewMonth, 1);
    var daysInMonth = new Date(calViewYear, calViewMonth + 1, 0).getDate();
    var startDay = (first.getDay() + 6) % 7;

    var now = new Date();
    var oslo = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Oslo' }));
    var todayStr = oslo.getFullYear() + '-' + String(oslo.getMonth() + 1).padStart(2, '0') + '-' + String(oslo.getDate()).padStart(2, '0');

    var hasAvailBefore = state.nextDates.some(function (d) {
      var p = parseDate(d);
      return p.getFullYear() < calViewYear || (p.getFullYear() === calViewYear && p.getMonth() < calViewMonth);
    });
    var hasAvailAfter = state.nextDates.some(function (d) {
      var p = parseDate(d);
      return p.getFullYear() > calViewYear || (p.getFullYear() === calViewYear && p.getMonth() > calViewMonth);
    });

    var monthLabel = MONTH_NAMES[calViewMonth].charAt(0).toUpperCase() + MONTH_NAMES[calViewMonth].slice(1) + ' ' + calViewYear;
    var dayHeaders = ['Ma', 'Ti', 'On', 'To', 'Fr', 'Lø', 'Sø'];

    var html = '<div class="fh-cal-head">' +
      '<button type="button" class="fh-cal-nav' + (hasAvailBefore ? '' : ' fh-cal-nav--hidden') + '" id="fh-cal-prev">' +
        '<svg width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg>' +
      '</button>' +
      '<span class="fh-cal-title">' + monthLabel + '</span>' +
      '<button type="button" class="fh-cal-nav' + (hasAvailAfter ? '' : ' fh-cal-nav--hidden') + '" id="fh-cal-next">' +
        '<svg width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M9 18l6-6-6-6"/></svg>' +
      '</button>' +
    '</div>';

    html += '<div class="fh-cal-days">';
    dayHeaders.forEach(function (dh) { html += '<span class="fh-cal-dh">' + dh + '</span>'; });

    for (var i = 0; i < startDay; i++) html += '<span class="fh-cal-empty"></span>';

    for (var d = 1; d <= daysInMonth; d++) {
      var dateStr = calViewYear + '-' + String(calViewMonth + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0');
      var isAvail = !!availSet[dateStr];
      var isSel = state.selectedDate === dateStr;
      var isPast = dateStr <= todayStr;

      var cls = 'fh-cal-day';
      if (isSel) cls += ' fh-cal-day--sel';
      else if (isAvail) cls += ' fh-cal-day--avail';
      else if (isPast) cls += ' fh-cal-day--past';
      else cls += ' fh-cal-day--off';

      if (isAvail || isSel) {
        html += '<button type="button" class="' + cls + '" data-date="' + dateStr + '">' + d + '</button>';
      } else {
        html += '<span class="' + cls + '">' + d + '</span>';
      }
    }
    html += '</div>';

    popup.innerHTML = html;

    popup.querySelector('#fh-cal-prev').addEventListener('click', function (e) {
      e.stopPropagation();
      calViewMonth--;
      if (calViewMonth < 0) { calViewMonth = 11; calViewYear--; }
      renderCalendarMonth(popup, w);
    });

    popup.querySelector('#fh-cal-next').addEventListener('click', function (e) {
      e.stopPropagation();
      calViewMonth++;
      if (calViewMonth > 11) { calViewMonth = 0; calViewYear++; }
      renderCalendarMonth(popup, w);
    });

    popup.querySelectorAll('.fh-cal-day--avail, .fh-cal-day--sel').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var picked = btn.dataset.date;
        state.selectedDate = picked;
        state.selectedSlot = null;
        saveState();

        var idx = state.nextDates.indexOf(picked);
        if (idx >= 0) {
          dateOffset = Math.max(0, Math.min(idx, state.nextDates.length - DATES_PER_PAGE));
        }

        closeCalendar();

        w.querySelectorAll('.fh-dcart-date').forEach(function (b) {
          b.classList.toggle('fh-dcart-date--sel', b.dataset.date === picked);
        });
        slideDates(w, _sliderCardWidth);
        updateArrowVisibility(w);
        loadSlots(w);
      });
    });
  }

  // ── Slots ─────────────────────────────────────────────────────────────────

  function loadSlots(w) {
    var container = w.querySelector('#fh-dcart-slots');
    if (!container || !state.zone || !state.selectedDate) return;

    container.style.opacity = '0.5';
    container.style.pointerEvents = 'none';

    getSlots(state.zone.id, state.selectedDate).then(function (data) {
      container.style.opacity = '1';
      container.style.pointerEvents = '';
      var slots = data.slots || [];
      state.slots = slots;

      if (!slots.length) {
        container.innerHTML = '<p class="fh-dcart-no-slots">Ingen tidsvinduer tilgjengelig</p>';
        return;
      }

      if (!state.selectedSlot) {
        var available = slots.filter(function (s) { return s.available > 0; });
        var recSlot = available.filter(function (s) { return s.recommended; });
        var autoSelect = recSlot.length > 0 ? recSlot[0] : (available.length > 0 ? available[0] : null);
        if (autoSelect) { state.selectedSlot = autoSelect.slot_id; saveState(); }
      }

      container.innerHTML = slots.map(function (s) {
        var sel = (state.selectedSlot === s.slot_id) ? ' fh-dcart-slot--sel' : '';
        var full = s.available === 0 ? ' fh-dcart-slot--full' : '';
        var few = (s.available > 0 && s.available <= 3) ? ' fh-dcart-slot--few' : '';
        var isRec = s.recommended && s.available > 0;
        var rec = isRec ? ' fh-dcart-slot--rec' : '';
        var capText = s.available === 0 ? 'Fullt' : s.available <= 3 ? 'Kun ' + s.available + ' plasser igjen' : s.available + ' plasser igjen';
        var slotCartTotal = getCartTotal();
        var slotFree = slotCartTotal >= 1000;
        var priceText = slotFree
          ? '<span class="fh-dcart-slot-price fh-dcart-slot-price--free">Gratis</span>'
          : '<span class="fh-dcart-slot-price">kr 130</span>';
        var recText = isRec
          ? '<span class="fh-dcart-slot-rec">Anbefalt</span>' +
            (s.recommendation_text ? '<span class="fh-dcart-slot-rec-text">' + esc(s.recommendation_text) + '</span>' : '')
          : '';

        return '<button type="button" class="fh-dcart-slot' + sel + full + few + rec + '" data-slot="' + s.slot_id + '"' + (s.available === 0 ? ' disabled' : '') + '>' +
          '<div class="fh-dcart-slot-radio"></div>' +
          '<div class="fh-dcart-slot-info">' +
            '<span class="fh-dcart-slot-time">' + formatTime(s.start) + ' – ' + formatTime(s.end) + '</span>' +
            '<span class="fh-dcart-slot-cap">' + capText + '</span>' +
          '</div>' +
          '<div class="fh-dcart-slot-right">' + priceText + recText + '</div>' +
        '</button>';
      }).join('');

      container.querySelectorAll('.fh-dcart-slot:not([disabled])').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state.selectedSlot = parseInt(btn.dataset.slot, 10);
          saveState();
          container.querySelectorAll('.fh-dcart-slot').forEach(function (b) { b.classList.remove('fh-dcart-slot--sel'); });
          btn.classList.add('fh-dcart-slot--sel');
          updateCutoff(w);
          updateTopPricing(w);
          updateCheckoutBtn(w, 'saving');
          syncCartAttributes().then(function () {
            updateCheckoutBtn(w, 'ready');
          }).catch(function () {
            updateCheckoutBtn(w, 'ready');
          });
        });
      });

      updateCutoff(w);
      updateTopPricing(w);
      updateCheckoutBtn(w);
    }).catch(function (err) {
      if (err === 'stale') return;
      container.style.opacity = '1';
      container.style.pointerEvents = '';
      container.innerHTML = '<p class="fh-dcart-no-slots">Kunne ikke hente tidsvinduer</p>';
    });
  }

  // ── Cutoff ────────────────────────────────────────────────────────────────

  function updateCutoff(w) {
    var el = w.querySelector('#fh-dcart-cutoff');
    if (!el || !state.selectedDate) return;
    var d = parseDate(state.selectedDate);
    d.setDate(d.getDate() - 1);
    var cutoff = DAY_NAMES_CAP[d.getDay()] + ' ' + d.getDate() + '. ' + MONTH_NAMES[d.getMonth()] + ' kl 23:59';
    el.innerHTML =
      '<svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>' +
      '<p>Bestill innen <strong>' + cutoff + '</strong></p>';
  }

  // ── Top pricing (always visible) ─────────────────────────────��────────────

  function updateTopPricing(w) {
    var el = w.querySelector('#fh-dcart-price-top');
    if (!el) return;

    var cartTotal = getCartTotal();
    if (cartTotal === null) cartTotal = 0;

    if (!state.postnr || !state.selectedSlot) {
      el.innerHTML =
        '<div class="fh-dcart-pt">' +
          '<div class="fh-dcart-pt-row"><span>Varer</span><strong>kr ' + formatNumber(cartTotal) + '</strong></div>' +
          '<div class="fh-dcart-pt-row"><span>Frakt</span><strong class="fh-dcart-pt-pending">Beregnes i kassen</strong></div>' +
          '<div class="fh-dcart-pt-frakt-sub">kr 130 \u00b7 gratis over 1 000 kr</div>' +
          '<div class="fh-dcart-pt-div"></div>' +
          '<div class="fh-dcart-pt-row fh-dcart-pt-total"><span>Totalt</span><strong>kr ' + formatNumber(cartTotal) + '</strong></div>' +
        '</div>';
      return;
    }

    var slotInfo = '';
    if (state.selectedDate && state.selectedSlot) {
      var slot = state.slots.find(function (s) { return s.slot_id === state.selectedSlot; });
      if (slot) {
        slotInfo =
          '<div class="fh-dcart-pt-delivery-info">' +
            '<span>' + formatDateShort(state.selectedDate) + ', ' + formatTime(slot.start) + '–' + formatTime(slot.end) + '</span>' +
          '</div>';
      }
    }

    el.innerHTML =
      '<div class="fh-dcart-pt">' +
        '<div class="fh-dcart-pt-row"><span>Varer</span><strong>kr ' + formatNumber(cartTotal) + '</strong></div>' +
        '<div class="fh-dcart-pt-row"><span>Frakt</span><strong class="fh-dcart-pt-pending">Beregnes i kassen</strong></div>' +
          '<div class="fh-dcart-pt-frakt-sub">kr 130 \u00b7 gratis over 1 000 kr</div>' +
        '<div class="fh-dcart-pt-div"></div>' +
        '<div class="fh-dcart-pt-row fh-dcart-pt-total"><span>Totalt</span><strong>kr ' + formatNumber(cartTotal) + '</strong></div>' +
        '<p class="fh-dcart-pt-mva">Inkl. MVA</p>' +
        slotInfo +
      '</div>';
  }

  // ── Checkout button state ─────────────────────────────────────────────────

  function updateCheckoutBtn(w, mode) {
    var actionDiv = w.querySelector('.fh-dcart-action');
    if (!actionDiv) return;
    if (!mode) {
      mode = (state.postnr && state.selectedDate && state.selectedSlot) ? 'ready' : false;
    }
    actionDiv.innerHTML = checkoutBtnHtml(mode);
    toggleNativeCheckout(mode === 'ready');
  }

  function toggleNativeCheckout(show) {
    var btns = document.querySelectorAll('.cart__checkout, .cart__buttons__fieldset [name=checkout], .additional-checkout-buttons, .cart__aside [data-checkout-buttons]');
    btns.forEach(function(b) { b.style.display = show ? '' : 'none'; });
  }

  // ── Utilities ─────────────────────────────────────────────────────────────

  var _cachedCartTotal = null;

  var _lastCartFetch = 0;
  var _cartFetchPromise = null;

  function fetchCartTotal() {
    var now = Date.now();
    if (_cartFetchPromise && now - _lastCartFetch < 2000) return _cartFetchPromise;
    _lastCartFetch = now;
    _cartFetchPromise = fetch('/cart.js').then(function (r) {
      if (!r.ok) return _cachedCartTotal;
      return r.json();
    }).then(function (cart) {
      if (cart && cart.total_price !== undefined) {
        _cachedCartTotal = cart.total_price / 100;
        var el = document.querySelector('[data-fh-cart-total]');
        if (el) el.dataset.fhCartTotal = _cachedCartTotal;
      }
      return _cachedCartTotal;
    }).catch(function () {
      return _cachedCartTotal || 0;
    });
    return _cartFetchPromise;
  }

  function getCartTotal() {
    if (_cachedCartTotal !== null) return _cachedCartTotal;
    var el = document.querySelector('[data-fh-cart-total]');
    if (el) return parseFloat(el.dataset.fhCartTotal) || 0;
    return 0;
  }

  function formatNumber(n) {
    return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  function trackEvent(name, params) {
    if (typeof gtag === 'function') {
      gtag('event', name, Object.assign({ event_category: 'levering' }, params || {}));
    }
  }

  // ── Update all ────────────────────────────────────────────────────────────

  function updateAllComponents() {
    initProductDelivery();
    initCartWidget();
  }

  // ── Cart drawer removal ────────────────────────────────────────────────
  // Drawer disabled: visual issues + allows checkout without delivery info.

  function disableCartDrawer() {
    var s = document.createElement('style');
    s.textContent = 'cart-drawer,#cart-drawer,.drawer--cart,.drawer__backdrop{display:none!important;visibility:hidden!important;pointer-events:none!important}' + ' .cart__checkout,.cart__buttons__fieldset [name=checkout],.additional-checkout-buttons,.cart__aside [data-checkout-buttons]{display:none!important}';
    document.head.appendChild(s);

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-toggle="cart-drawer"],[aria-controls="cart-drawer"],.js-drawer-open-cart,a[href="#cart-drawer"]')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        window.location.href = '/cart';
      }
    }, true);

    // Cart drawer buttons redirect to /cart (but normal add-to-cart stays on page)
  }

  // ── Init ──────────────────────────────────────────────────────────────────

  function cleanProductVariants() {
    // Product page: hide single-option selectors, sort multi-option
    if (window.location.pathname.indexOf('/products/') !== -1) {
      var wrappers = document.querySelectorAll('.selector-wrapper');
      wrappers.forEach(function (w) {
        var radios = w.querySelectorAll('input[type="radio"]');
        if (radios.length <= 1) { w.style.display = 'none'; return; }
        var fieldset = w.querySelector('.radio__fieldset');
        if (!fieldset) return;
        var items = Array.from(fieldset.querySelectorAll('.radio__button'));
        if (items.length < 2) return;
        items.sort(function (a, b) {
          var av = parseFloat((a.querySelector('input') || {}).value) || 0;
          var bv = parseFloat((b.querySelector('input') || {}).value) || 0;
          return av - bv;
        });
        items.forEach(function (item) { fieldset.appendChild(item); });
      });
    }
    // Global: fh-pi-chip — chip text comes from Liquid (option1 / option2), keep as-is
    document.querySelectorAll('.fh-pi-chips').forEach(function (container) {
      var chips = Array.from(container.querySelectorAll('.fh-pi-chip'));
      if (chips.length < 2) return;
      chips.sort(function (a, b) {
        return parseFloat(a.getAttribute('data-price') || 0) - parseFloat(b.getAttribute('data-price') || 0);
      });
      chips.forEach(function (c) { container.appendChild(c); });
    });
  }

  function init() {
    if (!document.getElementById('fh-dcart-spinner-css')) {
      var s = document.createElement('style');
      s.id = 'fh-dcart-spinner-css';
      s.textContent =
        '.fh-dcart-checkout-btn--saving{opacity:.45;pointer-events:none;cursor:default;}';
      document.head.appendChild(s);
    }
    disableCartDrawer();
    cleanProductVariants();
    setTimeout(cleanProductVariants, 800);
    setTimeout(cleanProductVariants, 2000);

    if (!API_BASE) {
      var meta = document.querySelector('meta[name="fh-delivery-api"]');
      if (meta) API_BASE = meta.getAttribute('content');
    }
    if (!API_BASE) return;

    var isCartPage = window.location.pathname === '/cart' || window.location.pathname === '/cart/';

    if (isCartPage) {
      var aside = document.querySelector('.cart__aside');
      if (aside) {
        aside.style.minWidth = '0';
        aside.style.overflow = 'hidden';
        var vw = window.innerWidth;
        if (vw >= 1440) aside.style.flex = '0 0 440px';
        else if (vw >= 1200) aside.style.flex = '0 0 400px';
        else if (vw >= 1024) aside.style.flex = '0 0 360px';
      }

      var themePrice = document.querySelector('.cart__price__holder');
      if (themePrice) themePrice.style.display = 'none';

      var zapiet = document.querySelector('#storePickupApp');
      if (zapiet) zapiet.style.display = 'none';
      var zapietWidget = document.querySelector('.zapiet-delivery-widget, [id*="zapiet"]');
      if (zapietWidget) zapietWidget.style.display = 'none';

      var oldInfo = document.querySelector('.fh-delivery-info');
      if (oldInfo) oldInfo.style.display = 'none';

      var oldShipping = document.querySelector('.fh-cart-shipping');
      if (oldShipping) oldShipping.style.display = 'none';

      var themeBtns = document.querySelector('.cart__buttons-wrapper');
      if (themeBtns) themeBtns.style.display = 'none';

      var themeNote = document.querySelector('em.cart__note');
      if (themeNote) themeNote.style.display = 'none';
    }

    initProductDelivery();

    if (isCartPage) {
      fetchCartTotal().then(function () {
        initCartWidget();
      }).catch(function () {
        initCartWidget();
      });

      document.addEventListener('theme:cart:change', function () {
        fetch('/cart.js', { cache: 'no-store' }).then(function (r) {
          return r.json();
        }).then(function (cart) {
          if (!cart || cart.total_price === undefined) return;
          _cachedCartTotal = cart.total_price / 100;
          var widgets = document.querySelectorAll('.fh-dcart');
          widgets.forEach(function (w) { updateTopPricing(w); updateCheckoutBtn(w); });
        }).catch(function () {});
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.FHDelivery = {
    init: init,
    checkPostnr: checkPostnr,
    getState: function () { return state; },
    clearState: clearState,
    refresh: updateAllComponents,
  };


  // ── Pre-fill checkout med postnr fra leveringswidget ───────────────────
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-fh-checkout]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    btn.classList.add('fh-dcart-checkout-btn--saving');
    syncCartAttributes().then(function () {
      var postnr = state.postnr || '';
      var params = [];
      if (postnr) {
        params.push('checkout[shipping_address][zip]=' + encodeURIComponent(postnr));
        params.push('checkout[shipping_address][country]=NO');
      }
      var url = '/checkout' + (params.length ? '?' + params.join('&') : '');
      window.location.href = url;
    }).catch(function () {
      btn.disabled = false;
      btn.classList.remove('fh-dcart-checkout-btn--saving');
    });
  });

})();